import { StateStorage } from 'zustand/middleware'
import { createStore } from '../.'

export type ConnectionProvider =
  | 'internet-identity-legacy'
  | 'internet-identity-v2'
  | 'plug'
  | 'oisy'
  | null

interface ConnectionProviderStore {
  provider: ConnectionProvider
  previousProvider: ConnectionProvider
  connectedAt: number | null
  setProvider: (provider: ConnectionProvider) => void
}

export const createConnectionProviderStore = (storage: StateStorage) =>
  createStore<ConnectionProviderStore>(
    storage,
    (set, get) => ({
      provider: null,
      previousProvider: null,
      connectedAt: null,
      setProvider: (provider) => {
        const oldState = get()

        set({
          provider,
          previousProvider: oldState.provider || provider || oldState.previousProvider,
          connectedAt: provider ? Date.now() : null,
        })
      },
    }),
    { persist: { name: 'connectionProvider', version: 0 } }
  )
